import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "field-service-management"
    }}>{`Field service management`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Many organizations perform services onsite at field locations involving installations, safety certifications, assessments, inspections, job orders, and more. Organizations benefit from streamlined digital document workflows to collect data, send for signature, create records, and archive for audit purposes. Customizing document workflows within different systems and applications can be challenging.`}</p>
    <p>{`Adobe Acrobat Services allows companies to:`}</p>
    <ul>
      <li parentName="ul">{`Integrate customized document processing with existing applications using APIs`}</li>
      <li parentName="ul">{`Automate approval and signature workflows to reduce processing errors`}</li>
      <li parentName="ul">{`Create dynamic data-driven documents with Microsoft Word templates`}</li>
      <li parentName="ul">{`Archive and secure documents of record for auditing`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A company needs to automate the creation and management of daily shift reports from multiple field locations. Shift reports follow a standard template, but some are completed manually and scanned while others are made dynamically using data from databases onsite. Daily reports from each location must be combined into a single report, approved with signature by the field manager, protected with a password, then stored as documents of record for audit purposes.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this solution`}</h3>
    <p>{`In this solution, shift reports in the field are scanned using Adobe Scan or generated in PDF format dynamically. Then they are combined with other reports, sent for approval with signature, password protected, and archived.`}</p>
    <ol>
      <li parentName="ol">{`A shift report is either scanned using Adobe Scan or generated dynamically using templates with form data and Adobe Document Generation API`}</li>
      <li parentName="ol">{`PDF Services API OCR service is used to make scanned PDFs readable and searchable`}</li>
      <li parentName="ol">{`PDF Services API Combine PDF service merges multiple PDFs`}</li>
      <li parentName="ol">{`Adobe Acrobat Sign API sends the final PDF for approval`}</li>
      <li parentName="ol">{`PDF Services API Protect service is used to add a password to the PDF before the document is archived`}</li>
      <li parentName="ol">{`Render the archived document in the application with Adobe PDF Embed API`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      